import type { ComponentProps, ReactNode } from 'react';
import { Button } from '@/components/ui/Button';
import { HoverTip } from '@/components/ui/HoverTip';

type ButtonOwnProps = ComponentProps<typeof Button>;

interface IconButtonProps
  extends Omit<ButtonOwnProps, 'aria-label' | 'children'> {
  'aria-label': string;
  children: ReactNode;
  tooltip?: ReactNode;
  tooltipAlign?: 'start' | 'center' | 'end';
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
}

export const IconButton = ({
  children,
  tooltip,
  tooltipAlign,
  tooltipPlacement,
  ...buttonProps
}: IconButtonProps) => {
  const button = <Button {...buttonProps}>{children}</Button>;

  return !tooltip ? (
    button
  ) : (
    <HoverTip align={tooltipAlign} placement={tooltipPlacement} text={tooltip}>
      {button}
    </HoverTip>
  );
};
